<template>
  <div class="gnb-slider">
    <Swiper
      v-scroll-spy-active="{ selector: '.gnb-slider__item', class: 'active' }"
      class="gnb-slider__swiper"
      :modules="modules"
      :slides-per-view="configStore.config.MenuGroupCountPerLine || 4"
      :free-mode="true"
      :space-between="0"
      @swiper="onSwiper"
      @slide-change="updateSwiper"
    >
      <SwiperSlide v-for="(menuGroup, index) in props.menuGroups" :key="index">
        <a :href="`#menu${index}`" class="gnb-slider__item" :class="{ active: currentActive === index }">
          <span>{{ getNameByLocale(menuGroup) }}</span>
        </a>
      </SwiperSlide>
    </Swiper>

    <div
      class="gnb-slider__prev"
      :class="{ disabled: isPrevDisabled }"
      @mouseup="handlePrevMenuGroupClick"
      @touchend.prevent="handlePrevMenuGroupClick"
    ></div>
    <div
      class="gnb-slider__next"
      :class="{ disabled: isNextDisabled }"
      @mouseup="handleNextMenuGroupClick"
      @touchend.prevent="handleNextMenuGroupClick"
    ></div>
  </div>
</template>

<script setup lang="ts">
  import MenuGroup from '@/interfaces/MenuGroup';
  import { useConfigStore } from '@/stores/config';
  import { useSwiperStore } from '@/stores/swiper';
  import { getNameByLocale } from '@/utils';
  import SwiperClass from 'swiper';
  import { FreeMode } from 'swiper/modules';
  import 'swiper/swiper-bundle.css';
  import { Swiper, SwiperSlide } from 'swiper/vue';
  import { ref } from 'vue';

  interface Props {
    menuGroups: MenuGroup[];
  }

  const configStore = useConfigStore();
  const props = defineProps<Props>();

  // swiper 에 사용 될 모듈
  const modules = ref([FreeMode]);
  // swiper 지정
  const gnbSwiper = ref();
  // 현재 활성화 된 메뉴
  const currentActive = ref(0);
  // 이전 버튼 비활성화 여부
  const isPrevDisabled = ref(false);
  // 다음 버튼 비활성화 여부
  const isNextDisabled = ref(false);

  /**
   * swiper 실행 시 해당 swiper option 할당
   * @param swiper
   */
  const onSwiper = (swiper: SwiperClass) => {
    gnbSwiper.value = swiper;
    useSwiperStore().setMenuGroupSwiper(swiper);
    isPrevDisabled.value = gnbSwiper.value?.isBeginning;
    setTimeout(() => {
      isNextDisabled.value = gnbSwiper.value?.isEnd;
    }, 500);
  };
  /**
   * 이전 메뉴 리스트로 이동
   */
  const handlePrevMenuGroupClick = () => {
    gnbSwiper.value?.slidePrev();
    isPrevDisabled.value = gnbSwiper.value?.isBeginning;
    isNextDisabled.value = gnbSwiper.value?.isEnd;
  };
  /**
   * 다음 메뉴 리스트로 이동
   */
  const handleNextMenuGroupClick = () => {
    gnbSwiper.value?.slideNext();
    isPrevDisabled.value = gnbSwiper.value?.isBeginning;
    isNextDisabled.value = gnbSwiper.value?.isEnd;
  };
  /**
   * 슬라이드 업데이트
   */
  const updateSwiper = () => {
    isPrevDisabled.value = gnbSwiper.value?.isBeginning;
    isNextDisabled.value = gnbSwiper.value?.isEnd;
  };
</script>
